// Angular Imports
import { inject } from '@angular/core'
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router'
// Shared Imports
import { ERoles } from '@shared/models'
import { AuthStore } from '@shared/store'

export const hasRolesGuard: CanActivateFn = (
	route: ActivatedRouteSnapshot,
	state: RouterStateSnapshot
) => {
	const router = inject(Router)
	const authStore = inject(AuthStore)

	const checkUserRoles = ({ rolesToVerify }: CheckUserRoles): boolean => {
		// We check if the received roles exist in the roles allowed for this user
		const allowedRoles: ERoles[] =
			(route && route.data['allowedRoles']) ?? route.data['allowedRoles']
		const atLeastOne = allowedRoles.some((role: ERoles) => rolesToVerify.includes(role))
		if (atLeastOne) {
			// console.log('[ROLES] Role Permission Granted')
			return true
		} else {
			// console.log('[ROLES] Role Permission Denied')
			router.navigate(['/dashboard'])
			return false
		}
	}

	return checkUserRoles({ rolesToVerify: authStore.roles() })
}

interface CheckUserRoles {
	rolesToVerify: ERoles[]
}
